import { Link } from "react-router-dom";
import Seo from "../../components/Seo";

export default function NotFoundPage() {
  return (
    <main>
      <Seo title="ページが見つかりません" noindex />
      <section className="page-hero ground" data-en="404">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <span>ページが見つかりません</span>
          </nav>
          <h1 className="page-title">
            ページが見つかりません<strong>Not Found</strong>
          </h1>
        </div>
      </section>
      <section className="section nd-sec">
        <div className="container">
          <div className="nd-body">
            <p>お探しのページは、移動または削除された可能性があります。</p>
            <p>お手数ですが、トップページかサービス一覧からお探しください。</p>
          </div>
          <div className="nd-back">
            <Link className="btn btn-sub" to="/">
              トップへ戻る
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
